import HeroBasic from '../components/HeroBasic'
import Card from '../components/Card'

function WhyThisMatters() {
    var heroTitle = "Why This Matters"
    var heroSubtitle = "Understanding the decline of environmental enforcement and public transparency."

    var cardHeader = "A Window into the Enforcement Process";

    return (
        <div>
            <HeroBasic title={heroTitle} subtitle={heroSubtitle} />
            <Card header={cardHeader}>
                <p>
                    EPA enforcement actions have declined sharply since early 2025 (<a href="https://peer.org/under-trump-epas-enforcement-of-environmental-laws-collapses-report-finds/">PEER Analysis</a>) (<a href="https://envirodatagov.org/publication/making-america-polluted-again-the-trump-epas-2025-enforcement-record/">EDGI Analysis</a>). The documents on this website can help the public see which environmental compliance issues have been identified but not acted on.  In some cases, these documents can supply what's needed for citizen suits to compel corrections, as well as support academic research, community organizing, and investigative journalism.  
                </p>

                <h2>EPA Enforcement Tracking is Backward and Unorganized</h2> 

                <p>
                    PEER and its partners have spent considerable time and effort obtaining and organizing EPA's enforcement records ourselves. The fact that EPA still lacks its own searchable database of enforcement documents points to an inefficiency that modern technology should have solved long ago. PEER's vision is straightforward: EPA should require its regional offices to standardize and digitize these documents, then make them searchable through a public database, such as ECHO. The technology already exists to do this. Doing so would be more efficient and cost effective for taxpayers and the public than the current paper system and the public request process. The current system of FOIA requests is extremely burdensome on the public and the government.  
                </p>

            </Card>
        </div>
    )
}

export default WhyThisMatters